export const submissionsConfig = {
  // Number of submissions per week (to calculate the submission queue length)
  postingRate: 3,

  // Minimum days into the future a post must be scheduled to show expedite nudges
  expediteThreshold: 7,
}
